import React, { useState } from 'react';

import { Button } from '@iq/react-components';
import SimpleModal from '../../../../SimpleModal/SimpleModal';
import NotificationRulesForm from '../NotificationRulesForm';
import { DEFAULT_STATE_CHANGE_SETTINGS } from '../../constants';

const EditModal = ({ config, roleName, onClose, onSave }) => {
  const [stateChangeSettings, setStateChangeSettings] = useState(
    config?.stateChangeSettings || { ...DEFAULT_STATE_CHANGE_SETTINGS }
  );

  const handleSave = () => {
    onSave({ stateChangeSettings });
  };

  return (
    <SimpleModal
      title="Edit"
      size="m"
      onClose={onClose}
    >
      <div className="edit-modal">
        <div className="edit-modal__role">
          <span className="edit-modal__role-label">Selected role</span>
          <span className="edit-modal__role-name">{roleName}</span>
        </div>
        <div className="edit-modal__section-title">Set up notification rules</div>
        <NotificationRulesForm
          stateChangeSettings={stateChangeSettings}
          onChange={setStateChangeSettings}
        />
        <div className="edit-modal__actions">
          <Button
            activity="secondary"
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button
            activity="primary"
            onClick={handleSave}
          >
            Save
          </Button>
        </div>
      </div>
    </SimpleModal>
  );
};

export default EditModal;
